export default __webpack_public_path__ + "static/media/BodyGame_07.cf1b6186.png";